<!-- order table显示列的定制 -->
<template>
<el-popover
    placement="bottom"
    :width="width"
    v-model="visible"
    trigger="hover"
>
    <div>
        <div>
            <slot></slot>
        </div>
    </div>
    <el-link slot="reference" :underline="false">
        <div class="wrap" >
            <icon-svg v-if="icon.indexOf('el-icon') ==-1" :icon-class="icon" font-size="27px;"/>
            <i v-else :class="icon" style="font-size:27px; color:#80DEEA; margin-bottom:3px;padding-top:5px;"/>
            <span class="txt">{{title}}</span>
        </div>
    </el-link>
</el-popover>

</template>

<script>


export default {
    name: "InventoryCtrl",
    data(){
        return {
            visible: false,
        }
    },
    props:{
        title: String,
        icon: String,
        width: {
            type: String,
            default: "120px"
        }
        
    },

}

</script>